import React, { useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import * as XLSX from "xlsx";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";
import { Alert, Snackbar } from "@mui/material";
import RestoreFromTrashRoundedIcon from "@material-ui/icons/RestoreFromTrashRounded";
import SocieteAndUserService from "../../../services/societeAndUser";
import uploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import SellingService from "../../../services/SellingService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import PurchaseService from "../../../services/PurchaseOrder";
import UploadPdfFile from "../../../ui/UploadPdfFile";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";

const DevisNonConfirme = ({ listDevis,userRole }) => {
  const navigate = useNavigate();

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [clients, setClients] = useState(listDevis);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [inConfirmedDevis, setInConfirmedDevis] = useState([]);
  const [devisUploadInformation, setDevisUploadInformation] = useState({
    reference: "any",
    state: 0,
    inConfirmedDevis: inConfirmedDevis,
  });
  const [onUploadFile, setOnUploadFile] = useState(false);
  const [devisRelatedToBC, setDevisRelatedToBC] = useState([]);
  const [archivedDevis, setArchivedDevis] = useState([]);
  const [devisRelatedToInvoice, setDevisRelatedToInvoice] = useState([]);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  // const selectOptions = {
  //   0: 0,
  //   3: 3
  // };

  const selectOptions = [{
    value: 0,
    label: 'Non validé'
  }, {
    value: 3,
    label: 'Lié à BDC'
  }];
  
  const { SearchBar } = Search;
  const fmt = (v) => v != null ? parseFloat(Number(v).toFixed(3)) : "";
  const MyExportExcel = () => {
    const handleExport = () => {
      const rows = listDevis.map((row) => ({
        "Réf":         row.reference,
        "Client":      row.clientTitle,
        "Prix.V.HT":   fmt(row.buyingPrice),
        "Prix.V.TT":   fmt(row.ttPrice),
        "TVA":         fmt(Number(row.ttPrice) - Number(row.buyingPrice)),
      }));
      const ws = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Devis");
      XLSX.writeFile(wb, `devis_vente_${new Date().toISOString().split("T")[0]}.xlsx`);
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleExport}>
          <i className="fas fa-file-excel"></i> Télécharger Excel
        </button>
      </div>
    );
  };
 

  
  const onArchiveHandler = (refDocument, isDeleted) => {
    SellingService.deleteAndRestoreDevis(refDocument, isDeleted)
      .then((response) => {
        if (Object.keys(response.data)[0] === "success") {
          window.location.reload(false);
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
  };

  function buttonDeleteFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        class="btn btn-danger btn-sm"
        onClick={() => onArchiveHandler(row.reference, 1)}
      >
        <i class="fas fa-trash"></i>
      </button>
    );
  }
 

  const onUploadFileHandler = (state, reference, isDeleted) => {
    SellingService.generateDevis(getCurrentUserId(), reference).then(
      (response) => {
        console.log("response", response);

        onShowFileInOtherWizndowHandler(response.data.devis.path);
      }
    );
  };
  function buttonFileFormatter(cell, row) {
    if (row.path === null||row.path === "any") {
      return (
        <span>
          <button
            style={{ width: 40 }}
            class="btn bg-gray btn-sm text-center"
            onClick={() =>
              onUploadFileHandler(row.state, row.reference, row.isDeleted)
            }
          >
            <i class="fas fa-plus"></i>
          </button>
        </span>
      );
    } else if (row.path !== null) {
      return (
        <button
          style={{ width: 40 }}
          class="btn bg-gray btn-sm "
          onClick={() =>
            onShowFileInOtherWizndowHandler(
              // UtilsUrl.sellingFileURL() +
              row.path
            )
          }
        >
          <i class="fas fa-eye"></i>
        </button>
      );
    }
  }

  
  const onValidateDevisHandler = (ref) => {
    sessionStorage.setItem("refDevis", ref);
    // sessionStorage.setItem("typeToTax", "Devis");
    navigate("/validateDevisBDCVente");
  };
  function buttonValidateCommandeFormatter(cell, row) {
    if(row.state===0){
   
      return <span>Non validé</span>
    }else if(row.state===1){
      return <span>Lié à commande</span>
    }else if(row.state===3){
      return <span>Lié à BDC</span>
    }
   
   
  }
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  const onValidateHandler = (idDevis) => {
    SellingService.validateDevis(getCurrentUserId(), idDevis)
      .then((response) => {
        if (Object.keys(response.data)[0] === "Bon_De_Commande") {
          setOpenSuccessAlert(true);
          setSuccessAlertText("Enregistrement avec succées");
          window.location.reload(true);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un erreur  ");
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
  };
  const onViewProductsHandler = (refDocument, NoteDocument) => {
    sessionStorage.setItem("refDocument", refDocument);
    sessionStorage.setItem("typeDocument", "devis");
    const pdfWindow = window.open();
    pdfWindow.location.href = "/getDocumentSalesByRef";
    // navigate("/getDocumentSalesByRef");
  };

  function buttonDetailsFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        class="btn bg-black btn-sm "
        onClick={() => onViewProductsHandler(row.reference, row.note)}
      >
        <i class="fas fa-shopping-cart"></i>
      </button>
    );
  }
  const onShowFileInOtherWizndowHandler = (path) => {
    uploadAndDownloadService
      .downloadFile(path)
      .then((response) => {
        //Build a URL from the file
        if (response.headers["content-type"] === "image/png") {
          const file = new Blob([response.data], { type: "image/png" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "application/pdf") {
          const file = new Blob([response.data], { type: "application/pdf" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpeg") {
          const file = new Blob([response.data], { type: "image/jpeg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        } else if (response.headers["content-type"] === "image/jpg") {
          const file = new Blob([response.data], { type: "image/jpg" });
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connexion");
      });
  };

  const columns = [
    {
      dataField: "reference",
      text: "Réf",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "clientTitle",
      text: "Client",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "note",
      text: "Note",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "creationDate",
      text: "DC",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "buyingPrice",
      text: "Prix.V.HT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "ttPrice",
      text: "Prix.V.TT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "path",
      text: "Fichier",
      formatter: buttonFileFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "state",
      text: "",
      // formatter: buttonValidateCommandeFormatter,
      formatter: cell => selectOptions.filter(opt => opt.value === cell)[0].label || '',
      filter: selectFilter({
        options: selectOptions
      }),
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "state",
      text: "Info",
      formatter: buttonDetailsFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "isDeleted",
      text: "Action",
      formatter: buttonDeleteFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    
  ];

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ products }) {
    return products;
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };
  
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Les devis de vente</h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={listDevis}
          columns={columns}
          onTableChange={handleTableChange}
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                <div className="ml-auto mr-0">
                  <MyExportExcel />
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                  filter={ filterFactory() }
                  //   expandRow={expandRow}
                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      {onUploadFile && (
        <UploadPdfFile
          setOnUploadFile={setOnUploadFile}
          setInConfirmedDevis={setInConfirmedDevis}
          setDevisRelatedToBC={setDevisRelatedToBC}
          setDevisRelatedToInvoice={setDevisRelatedToInvoice}
          devisUploadInformation={devisUploadInformation}
          setArchivedDevis={setArchivedDevis}
        />
      )}
    </div>
  );
};
export default DevisNonConfirme;
